import { render, staticRenderFns } from "./COM_HeaderNav.vue?vue&type=template&id=6fc4a1e8&scoped=true&"
import script from "./COM_HeaderNav.vue?vue&type=script&lang=js&"
export * from "./COM_HeaderNav.vue?vue&type=script&lang=js&"
import style0 from "./COM_HeaderNav.vue?vue&type=style&index=0&id=6fc4a1e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc4a1e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fc4a1e8')) {
      api.createRecord('6fc4a1e8', component.options)
    } else {
      api.reload('6fc4a1e8', component.options)
    }
    module.hot.accept("./COM_HeaderNav.vue?vue&type=template&id=6fc4a1e8&scoped=true&", function () {
      api.rerender('6fc4a1e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/components/COM_HeaderNav.vue"
export default component.exports